import cloneDeep from 'lodash/cloneDeep.js';
import isEmpty from 'lodash/isEmpty.js';

const CACHE_FIELD_PAIRS = [
    ['points_possible', 'points_possible_cache'],
    ['total_points_possible', 'total_points_possible_cache'],
    ['extra_credit_points', 'extra_credit_points_cache'],
    ['total_remediation_points', 'total_remediation_points_cache'],
];

export function normalizeCoursePointsBroadcast(payload) {
    const { activities = [], ...courseFields } = payload;

    const courseData = { ...courseFields };

    CACHE_FIELD_PAIRS.forEach(([field, cacheField]) => {
        if (courseData[field] === undefined || courseData[field] === null) {
            courseData[field] = courseFields[cacheField] ?? null;
        }
    });

    return {
        courseData,
        activities,
    };
}

export function applyActivityPointsToGradebook(gradebook, submissions, courseId, activities) {
    if (!gradebook?.activities?.length || isEmpty(activities)) {
        return;
    }

    const gradebookCourseId = gradebook.courseId || gradebook.course?.id;

    if (Number(gradebookCourseId) !== Number(courseId)) {
        return;
    }

    activities.forEach(activityUpdate => {
        const activity = gradebook.activities.find(item => Number(item.id) === Number(activityUpdate.id));

        if (!activity) {
            return;
        }

        const points = activityUpdate.points_possible;

        activity.points_possible = points;
        activity.activity_total = points;

        if (activity.activity_settings) {
            activity.activity_settings.points_possible = points;
        }

        gradebook.students?.forEach(student => {
            student.user?.grades?.forEach(grade => {
                if (Number(grade.activity_id) !== Number(activityUpdate.id)) {
                    return;
                }

                grade.activity_total = points;

                if (grade.activity) {
                    grade.activity.points_possible = points;
                }
            });
        });

        if (submissions?.[activityUpdate.id]) {
            Object.values(submissions[activityUpdate.id]).forEach(submission => {
                submission.activity_total = points;
            });
        }
    });
}

export function applyActivityPointsUpdates(state, { courseId, activities }) {
    if (isEmpty(activities)) {
        return;
    }

    const newState = cloneDeep(state);

    Object.values(newState.gradebook).forEach(gradebook => {
        applyActivityPointsToGradebook(gradebook, newState.submissions, courseId, activities);
    });

    state.gradebook = newState.gradebook;
    state.submissions = newState.submissions;
}
